import success from "../../../assets/success.png";
import styles from "../styles.module.scss";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getEvents } from "../../../requests";
import { useState } from "react";
import { Spin } from "antd";
import { AxiosError } from "axios";
import { getDateWithoutTime } from "../../../utils/formatDate";
import Button from "../../../custom/button/button";
import classNames from "classnames";
import EmptyState from "../../../custom/emptyState/emptyState";
import { ReactComponent as Clock } from "../../../assets/clock.svg";
import { formatCurrency } from "../../../utils/formatCurrency";
import { useRequery } from "../../../hooks/useRequery";

enum EventType {
  Training = 1,
  Conference = 2,
  Other = 3,
}

const content = (
  <div className={styles.modalContent}>
    <img src={success} alt="success" />
    <h2>Payment Successful!</h2>
    <p>You have successfully paid for your event.</p>
  </div>
);

const NonMemberOther = () => {
  const navigate = useNavigate();
  const [pageNumber] = useState(1);
  const PAGE_SIZE = 1000;
  const queryParams = `${pageNumber}${PAGE_SIZE}`;
  useRequery({
    modalContent: content,
  });

  const { data, isLoading, error, isError } = useQuery({
    queryKey: ["get-other", queryParams],
    queryFn: () =>
      getEvents({
        PageNumber: pageNumber,
        PageSize: PAGE_SIZE,
      }),
  });

  const otherData = data?.Data?.filter(
    (x) => x.EventTypeId === EventType.Other
  );

  if (isLoading) {
    return <Spin style={{ justifySelf: "center", alignSelf: "center" }} />;
  }

  if (isError) {
    return <div>{(error as AxiosError)?.message}</div>;
  }

  return (
    <div>
      <section className={styles.list}>
        {otherData && otherData.length > 0 ? (
          otherData?.map((item) => {
            const startDate = getDateWithoutTime(item?.StartDate);
            const endDate = getDateWithoutTime(item?.EndDate);
            const isEqual = item?.StartDate === item?.EndDate;
            return (
              <div className={styles.event} key={item.LearningEventId}>
                <div className={styles.columnGap}>
                  <h3>{item.EventName}</h3>
                  <small>THEME: {item?.Theme ?? item.EventCategoryName}</small>
                  <div className={styles.smallGap}>
                    <Clock />
                    <p className={styles.dates}>
                      {isEqual ? startDate : `${startDate} - ${endDate}`}{" "}
                      {item.VenueType ? `| ${item.VenueType}` : null}
                    </p>
                  </div>
                 <div className={styles.prices}>
                    <label className={styles.priceBadge}>
                      Non Member Amount :{" "}
                      {formatCurrency(parseFloat(item.NonMemeberAmount))}
                    </label>

                    {item?.StudentAmount && (
                      <label className={styles.priceBadge}>
                        Student Amount :{" "}
                        {formatCurrency(parseFloat(item.StudentAmount))}
                      </label>
                    )}

                    {item?.UndergraduateAmount && (
                      <label className={styles.priceBadge}>
                        Undergraduate Amount :{" "}
                        {formatCurrency(parseFloat(item.UndergraduateAmount))}
                      </label>
                    )}
                  </div>
               
                </div>
                <div className={styles.columnGap}>
                  <Button
                    onClick={() =>
                      navigate(
                        `/non-member-events/other/apply?learningEventId=${item.LearningEventId}`
                      )
                    }
                    className={classNames("nonMemberBtn")}
                    text="Individual Registration"
                  />
                  <Button
                    onClick={() =>
                      navigate(
                        `/non-member-events/other/apply?learningEventId=${item.LearningEventId}&isStudent=true`
                      )
                    }
                    className={classNames("nonMemberBtn")}
                    text="Student Registration"
                  />
                  <Button
                    onClick={() =>
                      navigate(
                        `/non-member-events/other/apply-as-org?learningEventId=${item.LearningEventId}`
                      )
                    }
                    className={classNames("nonMemberBtn")}
                    text="Corporate Registration"
                  />
                  <Button
                    onClick={() =>
                      navigate(
                        `/non-member-events/other/apply-as-undergraduate?learningEventId=${item.LearningEventId}`
                      )
                    }
                    className={classNames("nonMemberBtn")}
                    text="Undergraduate Registration"
                  />
                </div>
              </div>
            );
          })
        ) : (
          <EmptyState text="No events available" />
        )}
      </section>
    </div>
  );
};

export default NonMemberOther;
